import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  private baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  register(name: string, email: string, password: string, language: string, deviceType: string, operatingSystem: string, referrer: string, utmSource?: string, utmCampaign?: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/register`, { name, email, password, language, deviceType, operatingSystem, referrer, utmSource, utmCampaign });
  }

  socialRegister(idToken: string, deviceType: string, operatingSystem: string, referrer: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/social-register`, { idToken, deviceType, operatingSystem, referrer })
    .pipe(
      tap(response => {
        if (response && response.access_token) {
          localStorage.setItem('token', response.access_token);
          this.userService.isLoggedIn.next(true);
          this.userService.loadUser().subscribe();
        }
      })
    );
  }

  verifyEmail(token: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/verify-email`, { token });
  }

  resendVerificationEmail(email: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/resend-verify-email`, { email });
  }

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/login`, { email, password })
      .pipe(
        tap(response => {
          if (response && response.access_token) {
            localStorage.setItem('token', response.access_token);
            this.userService.isLoggedIn.next(true);
            this.userService.loadUser().subscribe();
          }
        })
      );
  }

  sendPasswordResetMail(emailAddress: string) {
    return this.http.post<any>(`${this.baseUrl}/user/reset-password-mail`, { emailAddress: emailAddress });
  }

  isResetPasswordTokenValid(token: string) {
    return this.http.post<any>(`${this.baseUrl}/user/reset-password/token-valid`, { token: token });
  }

  resetPassword(token: string, password: string) {
    return this.http.post<any>(`${this.baseUrl}/user/reset-password`, { token: token, password: password });
  }
}